/**
 * ProductAutocomplete Component
 * 
 * Async autocomplete for selecting products.
 * Uses the generic AsyncAutocomplete component (DRY).
 */
import { useCallback } from 'react';
import { Product } from 'types';
import { useApi } from 'api';
import AsyncAutocomplete from './AsyncAutocomplete';

interface Props {
  value: Product | null;
  onChange: (product: Product | null) => void;
}

/**
 * Get display label for a product
 */
const getProductLabel = (product: Product): string => {
  return product.label;
};

const ProductAutocomplete = ({ value, onChange }: Props) => {
  const api = useApi();

  const fetchProducts = useCallback(
    async (query: string, page: number) => {
      const { data } = await api.getSearchProducts({
        query,
        per_page: 10,
        page,
      });

      return {
        items: data.products,
        hasMore: data.pagination.page < data.pagination.total_pages,
      };
    },
    [api]
  );

  return (
    <AsyncAutocomplete<Product>
      value={value}
      onChange={onChange}
      fetchItems={fetchProducts}
      getLabel={getProductLabel}
      placeholder="Search a product"
      menuPortal
    />
  );
};

export default ProductAutocomplete;
